module.exports = __webpack_public_path__ + "img/login.f9810b77.svg";